import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["displayDiv", "formDiv"];

  confirmUpload(event) {
    const { displayDiv, formDiv, groupId } = this.resolveGroupTargets(event);
    if (!displayDiv || !formDiv) {
      if (groupId) {
        console.error(`Could not find display or form div for group: ${groupId}`);
      }
      return;
    }

    const cachedField = formDiv.querySelector(
      '[data-direct-upload-target="cachedField"]',
    );
    if (cachedField && !formDiv.dataset.originalCachedValue) {
      formDiv.dataset.originalCachedValue = cachedField.value || "";
    }

    displayDiv.classList.add("hidden");
    formDiv.classList.remove("hidden");
  }

  cancelUpload(event) {
    const { displayDiv, formDiv, groupId } = this.resolveGroupTargets(event);
    if (!displayDiv || !formDiv) {
      if (groupId) {
        console.error(`Could not find display or form div for group: ${groupId}`);
      }
      return;
    }

    const cachedField = formDiv.querySelector(
      '[data-direct-upload-target="cachedField"]',
    );
    if (cachedField && formDiv.dataset.originalCachedValue !== undefined) {
      cachedField.value = formDiv.dataset.originalCachedValue;
      delete formDiv.dataset.originalCachedValue;
    }

    const successMessage = formDiv.querySelector(
      '[data-direct-upload-target="successMessage"]',
    );
    const errorMessage = formDiv.querySelector(
      '[data-direct-upload-target="errorMessage"]',
    );
    const retryButton = formDiv.querySelector(
      '[data-direct-upload-target="retryButton"]',
    );
    if (successMessage) {
      successMessage.textContent = "";
      successMessage.classList.add("hidden");
    }
    if (errorMessage) {
      errorMessage.textContent = "";
      errorMessage.classList.add("hidden");
    }
    if (retryButton) {
      retryButton.classList.add("hidden");
    }

    displayDiv.classList.remove("hidden");
    formDiv.classList.add("hidden");
  }

  resolveGroupTargets(event) {
    const uploadGroup = event?.target?.closest?.("[data-reupload-group]");
    const groupId = uploadGroup?.dataset?.reuploadGroup;

    if (groupId) {
      const displayDiv = this.displayDivTargets.find(
        (div) => div.dataset.reuploadGroup === groupId,
      );
      const formDiv = this.formDivTargets.find(
        (div) => div.dataset.reuploadGroup === groupId,
      );
      return { displayDiv, formDiv, groupId };
    }

    return {
      displayDiv: this.displayDivTargets[0],
      formDiv: this.formDivTargets[0],
      groupId: null,
    };
  }
}
